import { ConfigurationState } from '@/types/Configuration';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ConfigurationState = {
  configurationTabValue: 'staff',
};

const configurationSlice = createSlice({
  name: 'configuration',
  initialState,
  reducers: {
    setConfigurationTabValue(state, action: PayloadAction<string>) {
      state.configurationTabValue = action.payload;
    },
  },
});

export const { setConfigurationTabValue } = configurationSlice.actions;
export default configurationSlice.reducer;
